import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { truncatedText } from '../styles/mixin'
import Typography from '../styles/typography'

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  className?: string
  as: HeadingTag
  size?: 'display1' | 'display2' | 'title1' | 'title2' | 'title3'
  weight?: 'normal' | 'medium' | 'bold'
  lineHeight?: number
  isTruncated?: boolean
  children: React.ReactNode
}

const StyledHeading = styled.h2<Props>`
  ${({ size = 'title1', weight, lineHeight, isTruncated }) => css`
    ${Typography[size]}
    ${weight && `font-weight: ${weight === 'medium' ? 500 : weight};`}
    ${lineHeight && `line-height: ${lineHeight}`}
    ${isTruncated && truncatedText}
  `}
`

export default function Heading({ className, as, size = 'title1', weight, isTruncated, lineHeight, children }: Props) {
  return (
    <StyledHeading
      as={as}
      className={className}
      size={size}
      weight={weight}
      isTruncated={isTruncated}
      lineHeight={lineHeight}
    >
      {children}
    </StyledHeading>
  )
}
